<template>
  <div
    class="flex md:items-center justify-between flex-col md:flex-row px-8 py-16 md:px-16 bg-grey-light-50 md:rounded-xl w-full gap-8"
  >
    <div>
      <h2 class="text-3xl font-semibold mb-5">{{ props.title }}</h2>
      <p class="text-xl md:text-xl text-gray-600">{{ props.description }}</p>
    </div>
    <div class="flex items-center justify-between flex-wrap gap-4">
      <Button variant="outline" size="lg" class="py-6 flex-auto min-w-0" @click="navigateToStores">
        See all stores
      </Button>
      <a :href="signUpUrl" class="max-md:w-full">
        <Button size="lg" class="py-6 flex-auto min-w-0 max-md:w-full">Get Started</Button>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { DASHBOARDS_URL } from '@/config';
import { useThemeStore } from '@/stores/theme';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

interface Props {
  title: string;
  description: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Payments made simple, for you.',
  description: 'Sign up for free or visit our stores to start shopping today.',
});

const router = useRouter();
const themeStore = useThemeStore();

const signUpUrl = computed((): string => {
  return `${DASHBOARDS_URL}/shopper/auth/sign-up`;
});

const navigateToStores = () => {
  router.push(`/${themeStore.current}/stores`);
};
</script>
